import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent } from '@ionic/react'
import { UseHeader, MktEmpty } from '@cps'
import { memberMobx } from '@mobxStore'
import { useGiftCardDecorationInit, useGiftCardPageTitle } from '@common/hooks'
import UnavailableCardItem from '../components/UnavailableCardItem'
import './index.scss'

import noGiftCardImg from '@img/no-giftcard.png'

interface IProps extends IPage, RouteComponentProps {
}

const GiftAvailable: FC<IProps> = ({ history }) => {
  const { giftListForExp } = memberMobx
  useGiftCardDecorationInit()
  useGiftCardPageTitle()
  return (
    <IonPage className='gift-available-page'>
      <UseHeader onBack={() => history.goBack()} title={i18n.t('mkt.giftCard.unavailableCard')}></UseHeader>
      <IonContent className='page-content'>
        {giftListForExp.length === 0 && <MktEmpty img={noGiftCardImg} />}
        {giftListForExp.length >= 0 &&
          <div className='log-body'>
            {
              giftListForExp.map((item: any, index: number) => {
                return (
                  <div className='log-block' key={index}>
                    <UnavailableCardItem cardInfo={item} key={index}></UnavailableCardItem>
                  </div>
                )
              })
            }
          </div>}
      </IonContent>
    </IonPage>
  )
}

export default observer(GiftAvailable)
